import { brandSourcesResponse, brandsResponse, BussinessTypesResponse, Distributor, DistributorsPhonesResponse, distributorsResponse, NoResponseRule, SegmentationItem, SourcesAndCampainsItem, templatesNoResponse, TimePeriod } from "@modules/configuration-ia/interfaces";
import { BotIA } from "@modules/configuration-ia/interfaces/bot-ia/bot-ia.interface";
import { AIConfigurationData, botSettings, iaHorario, iaPlantilla, SubbrandRelated } from "@modules/configuration-ia/interfaces/global/ai-config-data.interface";
import { signalStore, withState, withMethods, patchState } from "@ngrx/signals";

const startDate = '00:00:00'; // Establece la hora a las 00:00:00
const endDate = '23:59:59'; // Establece la hora a las 23:59:59.999

const configData: AIConfigurationData = {
  catalogs: {
    subcampains: [],
  },
  botSettingsInfo: {
    iarequest: {
      idia: '',
      titulo: '',
      tipo: null,
      idaccionnorespuesta: null,
      idplantillabienvenida: null,
      idtipodenegocio: '',
      idmarca: '',
      iddistribuidor: '',
      idfuente: '',
      idcampana: '',
      habilitarwhatsapp: false,
      nocontacto: 0,
      habilitartelefonia: false,
      agentes: 0,
      restingirhorarios: false,
      idproveedor: '',
      idcreado: '',
      nombreCreado: '',
      creado: '',
      activo: false,
      nocontactoperiodo: null,
      intentoDeRecontacto: false,
      numeroDeReintentos: 0,
      telefono: '',
      idPlantillaPlayground: '',
      idsegmento: '',
      segmento: '',
      prioridad: false,
      idSubmarca: '',
      submarca: '',
      citaDomicilio: false,
      maximoKm: 0,
      autorizado: false,
      atencion: 0,
      telefonoPg: '',
      flujoPool:false,
      idPool: '',
      tipoMarca: 0,
      marca: '',
      despuesDeChatbot: 0,
      idPeriodoChatbot: 0,
      idChatbot: '',
      idBdc: '',
      idDistribuidorBdc: '',
      canales: '',
      iddistribuidorlinea: '',
    },
    horarios: [
      {
        idhorario: '',
        inicio: startDate,
        fin: endDate,
        lunes: true,
        martes: true,
        miercoles: true,
        jueves: true,
        viernes: true,
        sabado: true,
        domingo: true,
        idCreado: new Date().toISOString(),
        creado: '',
      }
    ],
    promtingBienvenida: '',
    promtingDespedida: '',
    promtingRecontacto: '',
    submarcas: []
  },
  loadedBotInfo: false,
  editingBot: false
}
export const AIConfigurationStore = signalStore(
  { providedIn: 'root' },
  withState(configData),
  withMethods((store) => (
    {
      setAIConfigurationData(aiConfigData: AIConfigurationData) {
        patchState(store, aiConfigData);
      },
      cleanConfigurationData() {
        patchState(store, (state) => ({
          catalogs: state.catalogs,
          botSettingsInfo: configData.botSettingsInfo,
          loadedBotInfo: false
        }));
      },
      setCatalogs(catalogs: any) {
        patchState(store, (state) => ({
          catalogs: {...catalogs},
          botSettingsInfo: {...state.botSettingsInfo},
          loadedBotInfo: state.loadedBotInfo
        }));
      },
      setIndividualCatalog(
        catalog:
          'subcampains'|
          'brands'|
          'distributors'|
          'templatesNoResponse'|
          'bussinessTypes'|
          'timePeriods' |
          'distributorsPhones' |
          'botIaList'|
          'allBrandsSources'|
          'allSubcampains' |
          'segmentation' |
          'baseBrands' |
          'noResponse' |
          'subbrandsMultibrand' |
          'attentionTouch' |
          'channelsBase',
        value:
          brandSourcesResponse[] |
          brandsResponse[] |
          distributorsResponse[] |
          templatesNoResponse |
          BussinessTypesResponse |
          Distributor[] |
          TimePeriod[] |
          SourcesAndCampainsItem[] |
          DistributorsPhonesResponse[]|
          SegmentationItem[] |
          NoResponseRule[] |
          SegmentationItem[] |
          Boolean |
          {}) {
        patchState(store, (state) => ({
          catalogs: {
            ...state.catalogs,
            [catalog]: value
          },
          botSettingsInfo: state.botSettingsInfo,
          loadedBotInfo: state.loadedBotInfo,
        }))
      },
      setIARequestData(param: string, value: string | number | boolean | null) {
        patchState(store, (state) => ({
          botSettingsInfo: {
            ...state.botSettingsInfo,
            iarequest: {
              ...state.botSettingsInfo.iarequest,
              [param]: value
            }
          },
          loadedBotInfo: state.loadedBotInfo,
          catalogs: state.catalogs
        }));
      },
      setRecontactPrompting(prompting: string) {
        patchState(store, (state) => ({
          botSettingsInfo: {
            ...state.botSettingsInfo,
            promtingRecontacto: prompting,
          },
          loadedBotInfo: state.loadedBotInfo,
          catalogs: state.catalogs,
        }));
      },
      setIaTemplateData(value: number) {
        patchState(store, (state) => ({
          botSettingsInfo: {
            ...state.botSettingsInfo,
            iaPlantilla: {
              idPlantilla: value
            }
          },
          loadedBotInfo: state.loadedBotInfo,
          catalogs: state.catalogs
        }));
      },
      setIALoadedBotInfo(active: boolean, botSettingsInfo: botSettings) {
        patchState(store, (state) => ({
          botSettingsInfo: botSettingsInfo,
          loadedBotInfo: active,
          catalogs: state.catalogs
        }));
      },
      setAILoadedBotFlag(active: boolean) {
        patchState(store, (state) => ({
          botSettingsInfo: state.botSettingsInfo,
          loadedBotInfo: active,
          catalogs: state.catalogs
        }));
      },
      setAttentionSchedules(horarios: iaHorario[]){
        patchState(store, (state) => ({
          botSettingsInfo: {
            ...state.botSettingsInfo,
            horarios: horarios
          },
          loadedBotInfo: state.loadedBotInfo,
          catalogs: state.catalogs
        }));
      },
      setSubBrands(items: SubbrandRelated[]){
        patchState(store , (state) => ({
          botSettingsInfo : {
            ...state.botSettingsInfo,
            submarcas: items,
          },
          loadedBotInfo: state.loadedBotInfo,
          catalogs: state.catalogs,
        }));
      },
      addTemplate(template: iaPlantilla){
        patchState(store, (state) => ({
          botSettingsInfo: {
            ...state.botSettingsInfo,
            iaPlantilla: template
          },
          loadedBotInfo: state.loadedBotInfo,
          catalogs: state.catalogs,
          temporaryTemplateFlag: true
        }));
      },
      deleteBotFromList(bot: BotIA) {
        patchState(store, (state) => ({
          botSettingsInfo: state.botSettingsInfo,
          loadedBotInfo: state.loadedBotInfo,
          catalogs: {
            ...state.catalogs,
            botIaList: state.catalogs.botIaList?.filter((b: BotIA) => b.idia !== bot.idia)
          },
        }))
      },
      addBotToList(bot: BotIA) {
        patchState(store, (state) => ({
          botSettingsInfo: state.botSettingsInfo,
          loadedBotInfo: state.loadedBotInfo,
          catalogs: {
            ...state.catalogs,
            botIaList: [...state.catalogs.botIaList ?? [], bot]
          },
        }))
      },
      setEditingBot(status: boolean) {
        patchState(store, (state) => ({
          botSettingsInfo: state.botSettingsInfo,
          loadedBotInfo: state.loadedBotInfo,
          catalogs: state.catalogs,
          editingBot: status
        }))
      }
    }
  )),
);
